import { getErrorPayload } from '@application/helpers/api-helper';
import EmailTemplateSettingsApi from '@infrastructure/email-template-settings-api';
import { createAsyncThunk } from '@reduxjs/toolkit';
export const getEmailTemplateSettingsAsync = createAsyncThunk('emailTemplateSettings/get', async (emailTemplateId, { rejectWithValue }) => {
    try {
        const response = await EmailTemplateSettingsApi.getEmailTemplateSettings(emailTemplateId);
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const createEmailTemplateSettingsAsync = createAsyncThunk('emailTemplateSettings/create', async (request, { rejectWithValue }) => {
    try {
        const response = await EmailTemplateSettingsApi.createEmailTemplateSettings(request);
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const updateEmailTemplateSettingsAsync = createAsyncThunk('emailTemplateSettings/update', async (request, { rejectWithValue }) => {
    try {
        const response = await EmailTemplateSettingsApi.updateEmailTemplateSettings(request);
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const cancelEmailTemplateSettingsAsync = createAsyncThunk('emailTemplateSettings/cancel', async (request, { rejectWithValue }) => {
    try {
        const response = await EmailTemplateSettingsApi.cancelEmailTemplateSettings(request);
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const sendEmailTemplateAsync = createAsyncThunk('emailTemplateSettings/send', async (request, { rejectWithValue }) => {
    try {
        const response = await EmailTemplateSettingsApi.sendEmailTemplate(request);
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const getEmailTemplateScheduledStatusAsync = createAsyncThunk('emailTemplateSettings/scheduledStatus', async (eventId, { rejectWithValue }) => {
    try {
        const response = await EmailTemplateSettingsApi.getEmailTemplateScheduledStatus(eventId);
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
